import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

const FourthSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  const feedback = [
    {
      id: 1,
      name: 'Kishore Kumar Singh K',
      profilePic: 'images/kishore.jpg',
      comment:
        'App has a really good interface and animations look great. I got instant replies to my messages. One should definitely try this.',
    },
    {
      id: 2,
      name: 'Kavya Dhurv',
      profilePic: 'images/k.png',
      comment:
        'We can write our thoughts anonymously. Very good user interface and great design. Easy to use',
    },
    {
      id: 3,
      name: 'Amith G',
      profilePic: 'images/amit.jpg',
      comment:
        'Good user interface, and a different and useful initiative. Many unexpected, extra features as well. Worth the download.',
    },
  ];
  return (
    <div className="md:ml-10 md:mt-16 mx-4 md:mx-0">
      <div className="md:text-4xl font-semibold mb-4">
        What our Customers say
      </div>
      <div className="flex justify-center">
        <div className="w-4/5 md:w-3/5 flex justify-center items-center mb-8">
          <Slider
            {...settings}
            className="w-full md:w-3/5 md:h-2/4 rounded-3xl border-2 border-blue-400 shadow-xl"
          >
            {feedback.map((comm) => (
              <div key={comm.id} className="p-4 md:py-10">
                <div className="flex justify-center md:justify-start mb-4">
                  <img
                    className="md:h-13 md:w-13 rounded-full h-12 w-12"
                    src={comm.profilePic}
                    alt=""
                  />
                </div>
                <p className="text-sm md:text-base font-semibold">
                  {comm.comment}
                </p>
                <p className="text-sm mt-2 italic">- {comm.name}</p>
              </div>
            ))}
          </Slider>
        </div>
        <div className="hidden w-2/5 md:block relative overflow-hidden">
          <img
            className="w-full transform translate-x-36"
            src="images/connection.png"
            alt="Connection-pic"
          />
        </div>
      </div>
    </div>
  );
};

export default FourthSection;
